'use strict';

import { CONST } from 'app_vodafone_ziggo/util/util';

/**
 * @constant {Object} selectors - Used selectors for the Progress Indicator
 * @property {string} wrapper - The wrapper element
 * @property {string} item - An indicator item
 */
const selectors = {
    mainContainer: '.js-bscan-main',
    wrapper: '.js-bscan-step-progress',
    item: '.js-bscan-step-progress-item'
};

const classes = {
    activeIndicator: 'bscan-active-indicator'
};

/**
 * @class ProgressIndicator
 */
class ProgressIndicator {
    /**
     * @constructor
     * @property {HTMLElement} element - The Progress Indicator
     * @property {function} hide - Hides the progress indicator
     * @property {function} show - Shows the progress indicator
     * @property {function} activateNextStep - Actives the next possible indicator item.
     */
    constructor() {
        this.mainContainer = document.querySelector(selectors.mainContainer);
        this.element = document.querySelector(selectors.wrapper);

        this.hide = () => {
            if (this.mainContainer && this.element) {
                this.mainContainer.classList.remove(classes.activeIndicator);
                this.mainContainer.classList.add('hide-progress-indicator');
                this.element.classList.add(CONST.classes.hidden);
            }
        };

        this.show = () => {
            if (this.mainContainer && this.element) {
                this.mainContainer.classList.add(classes.activeIndicator);
                this.mainContainer.classList.remove('hide-progress-indicator');
                this.element.classList.remove(CONST.classes.hidden);
            }
        };
    }

    /**
     * @method activateNextStep
     * @param {string} targetStepIndex - The next step index to activate
     */
    activateNextStep(targetStepIndex) {
        const index = parseInt(targetStepIndex, 10);
        if (window.isNaN(index)) return;

        // Remove the active class from the current active progress indicator item
        const activeIndicatorItem = this.element.querySelector(`${selectors.item}.${CONST.classes.active}`);
        if (activeIndicatorItem) {
            activeIndicatorItem.classList.remove(CONST.classes.active);
        }

        // Add the active class to the new progress indicator item based on targetStepIndex
        const targetIndicatorItem = this.element.querySelector(`${selectors.item}:nth-child(${index + 1})`);
        if (targetIndicatorItem) {
            targetIndicatorItem.classList.add(CONST.classes.active);
        }
    }
}

export { ProgressIndicator };
